import {JustDate} from './JustDate'

function formatAsDollarValue(number, decimalPlaces = 2) {

    if (number == null) {
        return '$0.00'
    }

    if (typeof number === 'string') {
        if (number.length > 0 && number === '$') {
            return number
        }
        number = parseFloat(number)
    }

    decimalPlaces = typeof(decimalPlaces) === 'undefined' ? 2 : decimalPlaces

    const numberWithDecimals= number.toFixed(decimalPlaces).toString();
    let commaPosition = (numberWithDecimals.length - 3) % 3;
    commaPosition = commaPosition === 0 ? 3: commaPosition;

    let formattedNumber = "$" + numberWithDecimals.slice(0, commaPosition)
    while(commaPosition < (numberWithDecimals.length-3)){
        formattedNumber += "," + numberWithDecimals.slice(commaPosition, commaPosition + 3);
        commaPosition +=3;
    }

    //Add back on the decimal numbers and return
    return formattedNumber + numberWithDecimals.slice(commaPosition, commaPosition + 3);
}

/**
 * Mirrors a dollar amount into a "text" attribute for the MoneyColors.css
 * theme addition to pattern-match against - zero-padded so every power-of-
 * ten tier boundary becomes a plain starts-with prefix match in CSS.
 * Positive amounts are "+"-prefixed (negative already get a bare "-") so
 * MoneyColors.css can match only signed values, not any other label that
 * happens to reuse the "text" attribute for something unrelated.
 * @param {number} number
 * @return {string}
 */
function moneyText(number) {
    if (number == null) {
        number = 0
    }
    if (typeof number === 'string') {
        number = parseFloat(number)
    }
    if (isNaN(number)) {
        number = 0
    }
    if (number < 0) {
        return '-' + Math.trunc(Math.abs(number))
    }
    return '+' + String(Math.trunc(number)).padStart(10, '0')
}

/**
 * Mirrors a date's day-offset from today into a "text" attribute for the
 * DateColors.css theme addition to pattern-match against ("+"-prefixed =
 * future, bare "-" = past, "0" = today) - the "+" prefix (rather than a
 * bare positive number) so DateColors.css can match only signed values,
 * not any other label that happens to reuse the "text" attribute for
 * something unrelated. Returns null (React omits the attribute) for a
 * missing or not-yet-set date, so callers don't need their own null guard.
 * @param {JustDate} date
 * @return {?string}
 */
function dateOffsetText(date) {
    if (!date || typeof date.valueOf !== 'function' || date.valueOf() <= 0) {
        return null
    }
    const days = date.differanceDays(new JustDate())
    return days > 0 ? '+' + days : String(days)
}

export { formatAsDollarValue, moneyText, dateOffsetText }

